import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	carImage: {
		width: '100%',
		height: 'auto',
	},
	carName: {
		wordSpacing: '100vw',
	},
	officeImage: {
		maxWidth: '150px',
		maxHeight: '100px',
		height: 'auto',
		width: 'auto',
	},
	officeImageSmall: {
		maxWidth: '100px',
	},
	officeWrapper: {
		width: 'fit-content',
	},
	carHeaderWrapper: {
		minHeight: '100%',
	},
}));

export default useStyles;
